export enum PlannedMaintenanceDistributionFrequency {
  OneWeek = 0,
  OneMonth = 1,
  ThreeMonths = 2,
  SixMonths = 3,
  TwelveMonths = 4,
  TwentyFourMonths = 5,
  SixtyMonths = 6,
  Other = 7,
}
